// extracted by mini-css-extract-plugin
export default {"cover_img":"styles_cover_img__TKbWD","cover_bg":"styles_cover_bg__zLyPI"};